// Internal building block — consume via <ToggleGroup>.
import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import Button from './Button'

const BASE_CLASSES = [
  'tw:inline-flex',
  'tw:items-center',
  'tw:justify-center',
  'tw:whitespace-nowrap',
  'tw:py-2',
  'tw:px-3',
  'tw:text-sm'
].join(' ')

const radiusClasses = (isFirst, isLast) => {
  const left = isFirst ? 'tw:rounded-l-md!' : 'tw:rounded-l-none!'
  const right = isLast ? 'tw:rounded-r-md!' : 'tw:rounded-r-none!'
  return `${left} ${right}`
}

const buildClassName = (isFirst, isLast) => {
  const classes = [BASE_CLASSES, radiusClasses(isFirst, isLast)]
  if (!isFirst)
    classes.push('tw:border-l-0')
  return classes.join(' ')
}

// Stack a hidden semibold copy so the button width stays stable across active states.
const LABEL_STACK_CLASSES = 'tw:grid tw:[&>*]:col-start-1 tw:[&>*]:row-start-1'

const ToggleButton = ({ isActive, isFirst, isLast, label, value, onSelect }) => {
  const handleClick = useCallback(() => onSelect(value), [onSelect, value])
  return (
    <Button
      aria-pressed={isActive}
      className={buildClassName(isFirst, isLast)}
      variant={isActive ? 'primary' : 'neutral'}
      onClick={handleClick}
    >
      <span className={LABEL_STACK_CLASSES}>
        <span className="tw:invisible tw:font-semibold" aria-hidden>{label}</span>
        <span className={isActive ? 'tw:font-semibold' : 'tw:font-normal'}>{label}</span>
      </span>
    </Button>
  )
}

ToggleButton.propTypes = {
  isActive: PropTypes.bool.isRequired,
  isFirst: PropTypes.bool.isRequired,
  isLast: PropTypes.bool.isRequired,
  label: PropTypes.node.isRequired,
  onSelect: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
}

export default ToggleButton
